import type { Side } from 'driver.js';

import { AppRoutes } from '@/constants/routes';

export interface GuideStep {
  element: string;
  title: I18nKeys;
  description: I18nKeys;
  position?: Side;
  onNextNavigateTo?: string;
  onNextHandler?: () => Promise<void>;
  enable: boolean;
}

type AuthStore = ReturnType<typeof useAuthStore>;

export const getOnboardingSteps = (authStore: AuthStore): GuideStep[] => {
  const role = authStore.user?.role;

  return [
  // --- LOGO / HOME ---
    {
      element: '#logo-main',
      title: 'onboarding.logo.main.title',
      description: role
        ? `onboarding.logo.main.description.${role}`
        : 'onboarding.logo.main.description',
      position: 'right',
      onNextNavigateTo: AppRoutes.ROOT,
      enable: true,
    },
    // --- NOTIFICATIONS ---
    {
      element: '#sidebar-notification',
      title: 'onboarding.sidebar.notification.title',
      description: 'onboarding.sidebar.notification.description',
      position: 'right',
      enable: true,
    },
    // --- CONTACTS PAGE ---
    {
      element: '#sidebar-contacts',
      title: 'onboarding.sidebar.contacts.title',
      description: 'onboarding.sidebar.contacts.description',
      position: 'right',
      enable: true,
    },
    {
      element: '#lead-create-single',
      title: 'onboarding.contacts.createSingle.title',
      description: 'onboarding.contacts.createSingle.description',
      position: 'bottom',
      enable: authStore.isLeadProvider,
      onNextNavigateTo: AppRoutes.LEADS,
    },
    {
      element: '#lead-create-bulk',
      title: 'onboarding.contacts.createBulk.title',
      description: 'onboarding.contacts.createBulk.description',
      position: 'bottom',
      enable: authStore.isLeadProvider,
      onNextNavigateTo: AppRoutes.LEADS,
    },
    {
      element: '#lead-table-filters',
      title: 'onboarding.contacts.filters.title',
      description: 'onboarding.contacts.filters.description',
      position: 'right',
      enable: true,
      onNextNavigateTo: AppRoutes.LEADS,
    },

    // --- COMMISSIONS ---
    {
      element: '#sidebar-commissions',
      title: 'onboarding.sidebar.commissions.title',
      description: 'onboarding.sidebar.commissions.description',
      position: 'right',
      enable: authStore.isLeadProvider,
    },

    // --- USERS ---
    {
      element: '#sidebar-users',
      title: 'onboarding.sidebar.users.title',
      description: 'onboarding.sidebar.users.description',
      position: 'right',
      enable: authStore.isAdmin,
      onNextNavigateTo: AppRoutes.USERS,
    },

    {
      element: '#user-heading-buttons',
      title: 'onboarding.users.headingButtons.title',
      description: 'onboarding.users.headingButtons.description',
      position: 'bottom',
      enable: authStore.isAdmin,
      onNextNavigateTo: AppRoutes.USERS,
    },

    // --- EVENTS ADMIN ---

    {
      element: '#sidebar-eventsAdmin',
      title: 'onboarding.sidebar.eventsAdmin.title',
      description: 'onboarding.sidebar.eventsAdmin.description',
      position: 'right',
      enable: authStore.isAdmin,
      onNextNavigateTo: AppRoutes.ADMIN_EVENTS,
    },

    {
      element: '#event-admin-create',
      title: 'onboarding.events.admin.create.title',
      description: 'onboarding.events.admin.create.description',
      position: 'bottom',
      enable: authStore.isAdmin,
      onNextNavigateTo: AppRoutes.ADMIN_EVENTS,
    },

    // --- EVENTS MANDATARY ---
    {
      element: '#sidebar-eventsMandatary',
      title: 'onboarding.sidebar.eventsMandatary.title',
      description: 'onboarding.sidebar.eventsMandatary.description',
      position: 'right',
      enable: authStore.isMandatary,
      onNextNavigateTo: AppRoutes.MANDATARY_EVENTS,
    },

    {
      element: '#event-mandatary-propose',
      title: 'onboarding.events.mandatary.propose.title',
      description: 'onboarding.events.mandatary.propose.description',
      position: 'bottom',
      enable: authStore.isMandatary,
      onNextNavigateTo: AppRoutes.MANDATARY_EVENTS,
    },

    // --- PROFILE BADGE ---
    {
      element: '#profile-badge',
      title: 'onboarding.profileBadge.title',
      description: 'onboarding.profileBadge.description',
      position: 'right',
      enable: true,
    },
  ];
};
